<template>
  <bizgain-component-layout
    :is-next-btn-enabled="true"
    :col-width="{ 'mx-5 px-4': !$vuetify.breakpoint.xsOnly, 'mx-2': $vuetify.breakpoint.xsOnly }"
    view-port-height="170px"
    ref="bizgainComponentLayout"
  >
    <template v-slot:heading>
      {{ heading }}
    </template>
    <template v-if="!$vuetify.breakpoint.xsOnly" v-slot:sub-heading>
      {{ $t('message.bizgainOnboarding.businessPhoneNumberSubHeading') }}
    </template>
    <template v-slot:content>
      <v-flex
        xs12
        class="extract-business-details"
      >
        <v-flex xs12 md7 class="phone-number-input">
          <vue-tel-input
            :dropdown-options="getDropdownOptions()"
            :input-options="getInputOptions()"
            :invalid-msg="$t('message.bizgainOnboarding.mobileNumberValidationMessage')"
            :value="modelValue"
            :disabled="isUpdatingMobileNumber"
            :valid-characters-only="true"
            :show-invalid-message="showInvalidMessage"
            mode="national"
            @on-input="phoneNumberTyped"
            @validate="setPhoneObject"
            @focus="showInvalidMessage=false"
            @blur="isInvalidPhoneNo"
            v-show="isSendOtp"
          >
            <template v-if="!isShortenFlow" v-slot:icon-right>
              <div
                class="verify-text pt-3 unselectable"
                :class="{ 'append-text': ishintVisible, 'append-text-disabled': !ishintVisible }"
                @click="sendOtp()"
                v-if="showVerifyButton"
              >
                <v-icon small>
                  east
                </v-icon>
                <span>
                  {{ $t('message.bizgainOnboarding.verify') }}
                </span>
              </div>
              <div v-else>
                <v-progress-circular size="20" indeterminate />
              </div>
            </template>
          </vue-tel-input>
        </v-flex>

        <v-flex v-if="isSendOtp && ishintVisible" xs12 class="v-messages theme--light mt-1">
          {{ $t('message.bizgainOnboarding.businessPhoneNumberHint') }}
        </v-flex>
        <v-flex>
          <v-btn
            depressed
            outline
            class="w-5 ml-0 mt-3"
            color="primary"
            v-if="regionConfig && regionConfig.PhoneNoOptions === phoneNoOptions.optional && isSendOtp"
            @click="pageSkiped"
          >
            {{ $t('message.bizgainOnboarding.skipVerification') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 v-show="!isSendOtp">
          <div class="label">
            {{ $tc('message.bizgainOnboarding.mobileNumber') }}
          </div>
          {{ getCurrentValidNumber() }}
          <a @click="handleOtp()" v-if="!hideChangeNumber" class="change-number-text pl-1 pb-2 mb-2">
            {{ $t('message.bizgainOnboarding.changeNumber') }}
          </a>
        </v-flex>
        <v-flex xs12 v-show="!isSendOtp">
          <div class="label">
            {{ $tc('message.bizgainOnboarding.validateOtp') }}
          </div>
          <div class="validate-otp-text">
            {{ $tc('message.bizgainOnboarding.validateOtpTextForNumber') }}
          </div>
          <v-flex xs12 md7 pt-2>
            <custom-text-field
              :placeholder="'123456'"
              v-model="otp"
              :type="'number'"
              :classes="'pt-0 mt-0'"
              :name="'otp'"
              :autocapitalize="'off'"
              :autofocus="true"
              :hide-details="true"
              :autocomplete="'one-time-code'"
              :icon="'mdi-check'"
            >
              <template v-if="isValidatingOtp || isValidOtp" v-slot:appendedSlot>
                <v-fade-transition leave-absolute>
                  <v-progress-circular
                    v-if="isValidatingOtp"
                    size="24"
                    color="info"
                    indeterminate
                  />
                  <v-icon v-if="isValidOtp" color="primary">
                    check_circle
                  </v-icon>
                </v-fade-transition>
              </template>
            </custom-text-field>
          </v-flex>
          <div class="resend-counter pt-2" v-if="!hideResend">
            <div v-if="!timerCompleted">
              {{ $tc('message.bizgainOnboarding.resendOtp') }} {{ counter }}
            </div>
            <div v-else>
              <a @click="sendOtp(OTPChannelTypes.SMS)" class="change-number-text">
                {{ $t('message.bizgainOnboarding.resendOtp1') }}
              </a>
              <a @click="sendOtp(OTPChannelTypes.WHATSAPP)" class="change-number-text px-3">
                {{ $t('message.bizgainOnboarding.resendOtp2') }}
              </a>
            </div>
          </div>
        </v-flex>
        <v-layout class="checkbox-block pt-3" v-show="!isSendOtp">
          <v-checkbox color="primary ml-0" v-model="isWhatsAppUpdatesOpted">
            <template v-slot:label>
              <div>
                {{ $tc('message.bizgainOnboarding.whatsappMessage') }}
              </div>
              <v-img
                class="ml-1"
                :src="whatsappIcon"
                :lazy-src="whatsappIcon"
                alt="WhatsApp Icon"
                width="24"
                height="24"
              />
              <div class="ml-1">
                {{ $tc('message.bizgainOnboarding.whatsapp') }}
              </div>
            </template>
          </v-checkbox>
        </v-layout>
        <v-layout class="checkbox-block" v-show="!isSendOtp">
          <v-checkbox color="primary" v-model="isPrivacyPolicyAccepted">
            <template v-slot:label>
              <div>
                {{ $tc('message.bizgainOnboarding.privacyPolicyAccept') }}
                <v-tooltip disabled>
                  <template v-slot:activator="{ on }">
                    <a
                      :href="termsOfServiceLink"
                      target="_blank"
                      @click.stop
                      v-on="on"
                    >
                      {{ $t('message.bizgainOnboarding.termsOfService') }}
                    </a>
                  </template>
                </v-tooltip>
                {{ $tc('message.bizgainOnboarding.and') }}
                <v-tooltip disabled>
                  <template v-slot:activator="{ on }">
                    <a
                      :href="privacyPolicyLink"
                      target="_blank"
                      @click.stop
                      v-on="on"
                    >
                      {{ $t('message.bizgainOnboarding.alternatePrivacyPolicy') }}
                    </a>
                  </template>
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>
        </v-layout>
        <alert
          class="pb-2"
          v-if="!isPrivacyPolicyAccepted"
          :icon-color="'error'"
          :icon-width="`${ !$vuetify.breakpoint.xsOnly ? 'xs1' : 'xs2' }`"
          :outline="true"
          :outline-color="'error'"
          :message="$t('message.bizgainOnboarding.acceptPrivacyPolicy')"
          :col-width="'xs12 md8 sm12 lg8'"
        />
      </v-flex>
    </template>
    <template v-slot:btn-content>
      <v-flex v-if="isSendOtp && showVerifyButton && isShortenFlow" :class="{ 'xs2 pl-1 pt-3': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
        <v-btn
          depressed
          class="mx-0 w-100 next-btn-color primary-btn-xs"
          :disabled="!isValidPhoneNumber"
          @click="sendOtp()"
        >
          {{ $t('message.bizgainOnboarding.verify') }}
        </v-btn>
      </v-flex>
      <v-flex
        v-if="!isSendOtp"
        :class="{
          'shrink  mt-0': !$vuetify.breakpoint.xsOnly,
          xs12: $vuetify.breakpoint.xsOnly,
          'pl-2': $vuetify.breakpoint.smOnly
        }"
      >
        <v-btn
          depressed
          class="mx-0 w-100 next-btn-color primary-btn-xs"
          :disabled="!isPrivacyPolicyAccepted || !isOtpValid"
          :loading="isUpdatingMobileNumber"
          @click="updateBusinessDetails"
        >
          {{ nextButtonText }}
        </v-btn>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import {
  VFlex,
  VBtn,
  VCheckbox,
  VLayout,
  VImg,
  VTooltip,
  VProgressCircular,
  VFadeTransition,
  VIcon
} from 'vuetify/lib';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import { mapActions, mapGetters } from 'vuex';
import clearErrorByField from 'Mixins/clearErrorByField';
import { bizgainConfig, privacyPolicyLink, termsOfServiceLink, launchState, bizgainOnboardingRoutes, phoneNoOptions, OTPChannelTypes, onboardingSections, signupFlowSteps } from 'Features/bizgainOnboarding/constants';
import Alert from 'Components/Alert/Alert';
import Bugsnag from '@bugsnag/js';
import { Chat } from 'Mixins/chat';
import { validatePhoneNumber } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { Validator } from 'vee-validate';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const { sendEmailOtp, validateOtp } = new ApiService();
import { OtpAlreadyGeneratedException } from 'GlobalErrors/OtpAlreadyGeneratedException';
import { InvalidOtpException } from 'GlobalErrors/InvalidOtpException';
import onboardingRedirect from 'Mixins/onboardingRedirect';

export default {
  mixins: [clearErrorByField, Chat, onboardingRedirect],
  components: {
    VFlex,
    VBtn,
    BizgainComponentLayout,
    Alert,
    VCheckbox,
    VLayout,
    VImg,
    VTooltip,
    VProgressCircular,
    VFadeTransition,
    VIcon,
    CustomTextField
  },
  data() {
    return {
      whatsappIcon: bizgainConfig.whatsappIcon,
      privacyPolicyLink: privacyPolicyLink,
      termsOfServiceLink: termsOfServiceLink,
      isPrivacyPolicyAccepted: true,
      isWhatsAppUpdatesOpted: true,
      isUpdatingMobileNumber: false,
      phoneObject: {
        number: ''
      },
      modelValue: '',
      ishintVisible: true,
      bizgainOnboardingRoutes,
      showVerifyButton: true,
      isSendOtp: true,
      otp: null,
      counter: null,
      timerCompleted: false,
      verificationCount: [],
      hideChangeNumber: false,
      hideResend: false,
      counterTimerIntervals: [],
      showInvalidMessage: false,
      phoneNoOptions: phoneNoOptions,
      isValidOtp: null,
      isValidatingOtp: false,
      OTPChannelTypes,
      isValidPhoneNumber: false
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'isError', 'businessLocation', 'portalSupportNumber', 'regionConfig', 'portalDomain', 'region']),
    isOtpValid(){
      return this.otp && this.otp.length == 6;
    },
    heading(){
      if(this.isShortenFlow){
        return this.$t('message.bizgainOnboarding.businessPhoneNumberV2')
      }
      return this.$t('message.bizgainOnboarding.businessPhoneNumber')
    },
    nextButtonText(){
      if(this.isShortenFlow){
        return this.$t('message.bizgainOnboarding.businessPhoneNumberbutton')
      }
      return this.$t('message.bizgainOnboarding.next')
    },
    isShortenFlow(){
      if(this.businessDetails && this.businessDetails.shortenFlow){
        return true;
      }
      return false;
    }
  },
  mounted(){
    if (localStorage.getItem('phoneNumbers')) {
      this.$refs.bizgainComponentLayout.setNextBtnVisibility(true);
    }else{
      this.$refs.bizgainComponentLayout.setNextBtnVisibility(false);
    }
  },
  methods: {
    ...mapActions(['setCurrentRoute', 'updateMessage', 'patchBusinessDetails', 'clearMessages', 'setSignUpRequest', 'setCurrentSection', 'setCurrentSection', 'setSignUpSteps']),
    async updateBusinessDetails() {
      this.$refs.bizgainComponentLayout.setViewPortHeight('170px');
      this.$refs.bizgainComponentLayout.setNextBtnVisibility(true);
      let businessDetailsToUpdate = null;
      let isValid = await this.$validator.validate();
      if (isValid) {
        try{
          if (this.businessDetails) {
            let signUpRequest = {
              sessionId: this.businessDetails.sessionId,
              phoneNumber: this.getCurrentValidNumber(),
              portalDomain: this.portalDomain,
              region: this.region,
              otp: this.otp,
              password: null
            };
            this.isValidatingOtp = true;
            await validateOtp(signUpRequest);
            this.isUpdatingMobileNumber = true;
            this.setSignUpRequest(signUpRequest);
            businessDetailsToUpdate = JSON.parse(
              JSON.stringify(this.businessDetails)
            );
            this.isValidatingOtp = false;
            this.isValidOtp = true;
            if (businessDetailsToUpdate) {
              let businessPhoneNumber = this.getCurrentValidNumber();
              let isWhatsAppUpdatesOpted = this.isWhatsAppUpdatesOpted;
              Object.assign(businessDetailsToUpdate, { businessPhoneNumber, isWhatsAppUpdatesOpted });
              await this.updateUserProperties({ personalNumber: businessPhoneNumber });
              localStorage.removeItem('phoneNumbers');
              localStorage.removeItem('timerCompleted');
            }
          }
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: businessDetailsToUpdate
          };
          await this.patchBusinessDetails(payload);
          await this.redirect({ isAppFlow: true }, {}, false, launchState.BUSINESSDETAILSANIMATION, businessDetailsToUpdate);
          if(this.isError){
            this.isUpdatingMobileNumber = false;
          }
        } catch(error) {
          this.isUpdatingMobileNumber = false;
          this.isValidatingOtp = false;
          Bugsnag.notify(error);
          this.$refs.bizgainComponentLayout.setViewPortHeight('265px');
          if (error instanceof InvalidOtpException) {
            this.updateMessage({ type: 'info', message: this.$t('message.bizgainOnboarding.enterValidOtp') });
          } else {
            this.isValidOtp = true;
            this.updateMessage({ type: 'error', message: this.$t('message.bizgainOnboarding.failedToSaveMobileNumber') });
          }
        }
      }
    },
    isInvalidPhoneNo(){
      this.getCurrentValidNumber() ? this.showInvalidMessage = false : this.showInvalidMessage = true;
    },
    phoneNumberTyped()
    {
      this.ishintVisible = true;
      this.showInvalidMessage = false;
    },
    setPhoneObject(value)
    {
      this.phoneObject = value;
      this.isValidPhoneNumber = value.valid;
    },
    getDropdownOptions() {
      return {
        disabled: false,
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
        tabindex: 0,
        width: '390px'
      };
    },
    getInputOptions() {
      return {
        autocomplete: 'on',
        autofocus: false,
        ariaDescribedby: '',
        id: '',
        maxlength: 25,
        name: 'telephone',
        showDialCode: false,
        placeholder: `Ex: ${this.portalSupportNumber}`,
        readonly: false,
        required: true,
        tabindex: 0,
        type: 'tel',
        styleClasses: ''
      }
    },
    getCurrentValidNumber(){
      return this.phoneObject && this.phoneObject.valid && this.phoneObject.number
    },
    async sendOtp(channel) {
      let OTPChannels;
      if (!channel){
        OTPChannels = [this.OTPChannelTypes.SMS, this.OTPChannelTypes.WHATSAPP];
      }
      else{
        OTPChannels = [channel];
      }
      if(this.getCurrentValidNumber()){
        this.showInvalidMessage = false;
        this.ishintVisible = true;
        this.counterTimerIntervals.forEach(clearInterval);
        this.setTimerCompleted(false);
        let validNumber = this.getCurrentValidNumber();

        let number = this.getNumber(validNumber);
        if (number){
          if (number.retryCount >= 3){
            this.hideResend = true;
            this.showOtpInputView();
            return;
          }
        }
        else{
          if (this.verificationCount && this.verificationCount.length < 3){
            this.addNumber(validNumber);
            this.hideResend = false;
            if (this.verificationCount.length == 3){
              this.hideChangeNumber = true;
            }
          }
          else{
            this.hideChangeNumber = true;
            this.hideResend = true;
            this.showOtpInputView();
            return;
          }
        }
        this.$refs.bizgainComponentLayout.setViewPortHeight('170px');
        let isValid = await this.$validator.validate();
        if (isValid && validNumber && this.businessDetails) {
          this.showVerifyButton = false;
          try {
            this.clearMessages();
            let sendOtpRequest = {
              sessionId: this.businessDetails.sessionId,
              phoneNumber: validNumber,
              portalDomain: this.portalDomain,
              otpChannels: OTPChannels
            }
            this.startTimer(this);
            // removing await purposefully
            sendEmailOtp(sendOtpRequest);
            this.increaseRetryCount(validNumber);
          } catch (error) {
            if (error instanceof OtpAlreadyGeneratedException) {
              this.$refs.bizgainComponentLayout.setViewPortHeight('265px');
              this.updateMessage({ type: 'info', message: this.$t('message.bizgainOnboarding.otpIsAreadyGenerated') });
            } else {
              this.updateMessage({ type: 'error', message: this.$t('message.bizgainOnboarding.failedToSendOtp') });
            }
          } finally {
            this.showOtpInputView();
          }
        }
      }
      else {
        this.showInvalidMessage = true;
        this.ishintVisible = false;
      }
    },
    handleOtp() {
      this.isSendOtp = !this.isSendOtp;
      this.counterTimerIntervals.forEach(clearInterval);
      this.counter = 60;
      this.$refs.bizgainComponentLayout.setNextBtnVisibility(false);
    },
    setTimerCompleted(val){
      localStorage.setItem('timerCompleted', val);
      this.timerCompleted = val;
    },
    startTimer(self){
      var downloadTimer = setInterval(function(){
        self.counter = self.counter - 1;
        if(self.counter <= 0){
          clearInterval(downloadTimer);
          self.setTimerCompleted(true);
          self.counter = 60;
        }
      }, 1000);
      self.counterTimerIntervals.push(downloadTimer);
    },
    getNumber(num){
      return num ? this.verificationCount.find(vc => vc.number == num) : null;
    },
    increaseRetryCount(num){
      var index = this.verificationCount.findIndex(vc => vc.number == num);
      this.verificationCount[index].retryCount += 1;
      this.updateLocalStorage();
    },
    addNumber(num){
      let newNumber = {
        'number': num,
        'retryCount': 0
      }
      this.verificationCount.push(newNumber);
      this.updateLocalStorage();
    },
    updateLocalStorage(){
      localStorage.setItem('phoneNumbers', JSON.stringify(this.verificationCount));
    },
    showOtpInputView(){
      this.isSendOtp = false;
      this.showVerifyButton = true;
      this.$refs.bizgainComponentLayout.setNextBtnVisibility(true);
    },
    pageSkiped(){
      // redirecting using mixin
      this.redirect({ isAppFlow: true }, {}, false, launchState.BUSINESSDETAILSANIMATION, null);
    }
  },
  created(){
    this.counter = 60;
    if (this.businessDetails){
      if (this.businessDetails.businessPhoneNumber){
        this.modelValue = this.businessDetails.businessPhoneNumber;
      }
    }
    let phoneNumber = localStorage.getItem('phoneNumbers');
    if (phoneNumber) {
      this.verificationCount = JSON.parse(phoneNumber);
      if(!this.modelValue){
        this.modelValue = this.verificationCount[this.verificationCount.length - 1].number;
      }
      if (this.verificationCount[this.verificationCount.length - 1].retryCount >= 3){
        this.hideResend = true;
      }
      if (this.verificationCount.length > 2){
        this.hideChangeNumber = true;
      }
      this.isSendOtp = true;
      this.isValidPhoneNumber = true;
    }

    Validator.extend('phoneNumber', {
      getMessage: field => 'The ' + field + ' value is invalid.',
      validate: value => { return validatePhoneNumber(value)  }
    });

    if(this.isShortenFlow){
      this.setCurrentSection(onboardingSections.signup);
      this.setCurrentRoute(bizgainOnboardingRoutes.BusinessPhoneNumber.name);
      this.setSignUpSteps(signupFlowSteps);
    }
    this.setCurrentRoute(bizgainOnboardingRoutes.BusinessPhoneNumber.name);

    var timerDone = localStorage.getItem('timerCompleted');
    if (timerDone){
      this.timerCompleted = true;
    }

    // to autofill otp
    if ('OTPCredential' in window) {
      window.addEventListener('DOMContentLoaded', e => {
        const input = document.querySelector('input[autocomplete="one-time-code"]');
        if (!input) return;
        const ac = new AbortController();
        navigator.credentials.get({
          otp: { transport: ['sms'] },
          signal: ac.signal
        }).then(otp => {
          this.otp = otp.code;
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .v-input__control {
    margin-top: 4px !important;
  }
  ::v-deep.append-text {
    cursor: pointer;
    font-size: 14px;
    margin-left: auto;
    color: var(--v-primary-base);
  }
  ::v-deep.append-text-disabled {
    font-size: 14px;
    margin-left: auto;
    color: var(--v-disabled-base);
  }
  ::v-deep.extract-business-details {
    .checkbox-block{
      .v-input--selection-controls {
        margin: 0 !important;
        padding: 0 !important;
        height: 6vh;
        .v-input__slot{
          margin: 0 !important;
          padding: 0 !important;
        }
      };
      a{
        text-decoration: underline;
      }
    };
    .phone-number-input{
      .v-input__slot:before {
        border-style: none;
      }
    }
  }
  ::v-deep.validate-otp-text {
    font-size: 12px;
    color: var(--v-disabled-base);
  }
  ::v-deep.change-number-text {
    text-decoration: underline;
    columns: var(--v-primary-base);
    font-size: 15px;
    line-height: 1.33;
  }
  ::v-deep.resend-counter {
    color: var(--v-subtitle-base);
    font-size: 15px;
    line-height: 1.33;
  }
  .verify-text {
    font-weight: 500 !important;
    display: flex;
    flex-wrap: nowrap;
  }
  .unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>